import React, { useContext } from 'react';
import SetOfCircleIcons from 'commonComponents/icons/SetOfCircleIcons/SetOfCircleIcons';
import { getIcons } from '../../../images';
import { LegendContext } from '../../Transfer';
import styles from './FirstStep.module.scss';

const FirstStep = ({ header, text }) => {
  const legend = useContext(LegendContext);
  const icons = getIcons(['natar', 'wa'], legend);

  return (
    <div className={ styles.FirstStep }>
      <SetOfCircleIcons icons={icons} additionalClass={ styles.icon } />
      <h4 className={ styles.header }>1. { header }</h4>
      <p className={ styles.text }>{ text }</p>
    </div>
  );
};

export default FirstStep;
